import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { message, Spin, notification, Modal } from 'antd'

import Policy from './views/policy';
import { checkIssetLogin, dimens } from './config/settings';
import {
  MainlayoutView, LoginView, RegisterView, CallcenterCallbackView, BookingClientView, FeedbackView, RegisterEmailView,
  CompanyReportView
} from './views';
import { notifyBrowser, postMessageApp } from './lib/helpers';
import { fetchData } from './lib/apis';

import { WidgetFotterApp, WidgetSwipe } from './widgets';

class AppComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    let isAppNative = localStorage.getItem('isApp');
    let statusBarHeight = localStorage.getItem('statusBarHeight');

    let locationSearch = new URLSearchParams(window.location.search);
    this.state = {
      UserLogin: null,
      activeTabBrowser: true,
      isAppNative: locationSearch.get("isApp") == 1 || isAppNative ? true : false,
      stateBackground: "active",
      statusBarHeight: parseInt(locationSearch.get('statusBarHeight') || statusBarHeight || 0),
      isMobile: this.checkMobile(),
      totalNoti: 0
    }
    if (this.state.isAppNative) {
      localStorage.setItem("isApp", 1);
    }
    localStorage.setItem("statusBarHeight", this.state.statusBarHeight);
    this.notificationMain = this.notificationMain.bind(this);
    this.deviceType = this.getMobileOperatingSystem();
  }
  componentWillMount = () => {
    console.log(dimens)
    let _this = this;
    window.addEventListener('visibilitychange', function () {
      _this.setState({
        activeTabBrowser: !_this.state.activeTabBrowser
      })
    })
    if (this.state.isAppNative) window.onmessage = (payload) => {
      if (typeof payload.data == "string") {
        let json = JSON.parse(payload.data);
        if (json.type == "appStateChange") {
          _this.stateBackgroundChange(json);
        }
      }
    }
    if (this.state.isAppNative) document.addEventListener('message', function (payload) {
      if (typeof payload.data == "string") {
        let json = JSON.parse(payload.data);
        if (json.type == "appStateChange") {
          _this.stateBackgroundChange(json);
        }
      }
    })
  }
  componentDidMount = () => {
    if (!localStorage.getItem("read_noti_m") && checkIssetLogin()) {
      setTimeout(() => {
        // this.notificationMain();
      }, 1000)
    }
  }
  notificationMain = () => {
    Modal.info({
      title: 'Thông báo',
      className: 'modal-noti',
      content: (
        <div className="content">
          <p>Hệ thống mới nâng cấp, người dùng dịch vụ <strong>Fanpage</strong> vui lòng cập nhập lại page để tiếp tục sử dụng.</p>
          <p style={{ marginBottom: "0px" }}>Xin cảm ơn!</p>
        </div>
      ),
      onOk() {
        localStorage.setItem("read_noti_m", 1);
      },
    });
  }

  notification = (options) => {
    let { type, title, content, key, duration, placement } = options;
    placement = placement ? placement : "topRight";
    type = type ? type : 'success';
    notification[type]({
      message: title,
      description: content,
      key: key,
      duration: duration,
      placement: placement
    })
  }
  message = (options) => {
    let { type, key, content, duration } = options;
    type = type ? type : 'success';

    message[type]({
      content: content,
      key: key,
      duration: duration
    })
  }

  copyText = (text) => {
    let el = document.querySelector('#input-copy');
    el.textContent = text;
    el.select();
    document.execCommand("copy");
    this.notification({
      title: 'Copy text',
      content: 'Thao tác thành công!',
      type: "success"
    });
  }

  sleep = (ms) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, ms);
    })
  }

  stateBackgroundChange = (value) => {
    this.setState({
      stateBackground: value.state
    }, () => {
      try {
        let company_id = this.state.company ? this.state.company.company_id : 0;

        postMessageApp({
          type: 'updateDeviceId',
          url: `${process.env.REACT_APP_API_CHOTSALE_URL}/api/v1/user/device/ping?auth_token=${dimens['df_t']}`,
          method: 'post',
          user_id: '',
          data: {
            ...value,
            company_id: company_id
          }
        })
      } catch (err) {

      }
    })
  }

  checkMobile = () => {
    let check = false;
    try {
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(window.navigator.userAgent || window.navigator.vendor || window.opera);
    } catch (err) {

    }
    return check;
  }

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  getLinkCallBack = (code, type) => {
    return `${window.location.origin}/callcenter/callback?type=${type || 2}&code=${code}`
  }

  getLinkBooking = (code) => {
    return `${window.location.origin}/lichhen?ref=${code}`
  }

  render() {
    let props_m = {
      notification: this.notification,
      message: this.message,
      copyText: this.copyText,
      sleep: this.sleep,
      notifyBrowser: notifyBrowser,
      activeTabBrowser: this.state.activeTabBrowser,
      postMessageApp: postMessageApp,
      isAppNative: this.state.isAppNative,
      stateBackground: this.state.stateBackground,
      statusBarHeight: this.state.statusBarHeight,
      isMobile: this.state.isMobile,
      fetchData: fetchData,
      handleCompany: (value) => this.setState({ company: value }),
      deviceType: this.deviceType,
      getLinkBooking: this.getLinkBooking,
      getLinkCallBack: this.getLinkCallBack,
      totalNoti: this.state.totalNoti,
      handleTotalNoti: (value) => this.setState({ totalNoti: value })
      // isAppNative: 1,
      // statusBarHeight: 15
    }
    const footerApp = <WidgetFotterApp visible={this.state.isAppNative} numMessage={this.state.totalNoti} />;
    return (
      <div className={`${this.state.isAppNative ? "app-native" : ""}`} style={{ width: "100%", height: "100%" }}>
        <Router>
          <WidgetSwipe id="box-touch-left" event="swiperight" action={() => {
            window.history.back();
          }} visible={this.deviceType == "iOS" && this.state.isAppNative} zIndex={102} />

          <textarea id="input-copy" style={{ opacity: 0, position: 'absolute', zIndex: 0, width: "1px", height: "1px", top: "-100px" }} onKeyPress={(e) => { e.preventDefault(); return false }} readOnly />
          <Switch>
            <Route exact path="/login" render={props => <LoginView {...props} {...props_m} />} />
            <Route exact path="/register" render={props => <RegisterView {...props} {...props_m} />} />

            <Route
              exact
              path='/policy'
              render={props => <Policy {...props} />}
            />

            <Route
              exact
              path='/callcenter/callback'
              render={props => <React.Fragment>
                {footerApp}
                <CallcenterCallbackView {...props} {...props_m} />
              </React.Fragment>}
            />
            <Route
              exact
              path='/lichhen'
              render={props => <React.Fragment>
                {footerApp}
                <BookingClientView {...props} {...props_m} />
              </React.Fragment>}
            />


            <Route
              exact
              path='/:company_id/gop-y'
              render={props => <React.Fragment>
                {footerApp}
                <FeedbackView {...props_m} {...props} />
              </React.Fragment>}
            />

            <Route
              exact
              path='/:company_id/dangky-email'
              render={props => <React.Fragment>
                {footerApp}
                <RegisterEmailView {...props_m} {...props} />
              </React.Fragment>}
            />



            <Route
              exact
              path='/:company_id/bao-cao'
              render={props => <React.Fragment>
                {footerApp}
                <CompanyReportView {...props_m} {...props} />
              </React.Fragment>}
            />

            <Route
              path='*'
              render={props => {
                return <React.Fragment>
                  {footerApp}
                  <MainlayoutView {...props} {...props_m} />
                </React.Fragment>
              }}
              history={(e) => console.log(e)}
            />

          </Switch>
        </Router>
      </div>
    )
  }
}
export default AppComponent;
